import { createFeature, createReducer, on } from '@ngrx/store';
import type { ModelTracking } from '../../utilities/tracking';
import { actions } from './tracking.actions';

interface TrackingState {
    disableTracking: boolean;
    currentModelsOnPage: ModelTracking[];
}

const initialState: TrackingState = {
    disableTracking: false,
    currentModelsOnPage: [],
};

export const state = createFeature({
    name: 'tracking',
    reducer: createReducer(
        initialState,
        on(
            actions.disableEventTracking,
            (state): TrackingState => ({
                ...state,
                disableTracking: true,
            }),
        ),
        on(
            actions.setModelsOnPageTracking,
            (state, action): TrackingState => ({
                ...state,
                currentModelsOnPage: action.models,
            }),
        ),
        on(
            actions.resetModelsOnPageTracking,
            (state): TrackingState => ({
                ...state,
                currentModelsOnPage: [],
            }),
        ),
    ),
});
